module.exports = __webpack_public_path__ + "static/media/profile.ef10afbc.png";